/* eslint-disable react/prop-types */
import React from 'react';
import ErrorBoundaryContent from '../error_boundary_content';
class ErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    //getDerivedStateFromError(error)
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <ErrorBoundaryContent />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
